import { render } from "./OurCompanyView.vue?vue&type=template&id=34cf5330"
import script from "./OurCompanyView.vue?vue&type=script&lang=js"
export * from "./OurCompanyView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__